const APIS = {
    
    STAFF: "/usermanagementservice/api/staff/",
    USER: "/usermanagementservice/api/user/",
    USER_PROFILE: "/usermanagementservice/api/user-profile/",
    GROUP:"/usermanagementservice/api/role/",
    PERMISSIONS: "/usermanagementservice/api/permissions/",

  };
  
  export default APIS;